import styled from '@emotion/styled'

export const SearchMapWrapper = styled.div`
  position: sticky;
  top: 0;
  display: block;
  flex: auto;
  height: calc(var(--vh) * 100);
  line-height: 1;

  visibility: unset !important;
  width: unset !important;

  .gm-style iframe + div {
    border: none !important;
  }

  //support ipad pro
  @media (max-width: 768px) {
    padding-top: 0px;

    .gmnoprint.gm-bundled-control {
      display: none;
    }
  }

  .gmnoprint.gm-bundled-control > .gmnoprint > div {
    border-radius: 8px !important;
  }

  @media (min-width: 768px) {
    .gmnoprint.gm-bundled-control > .gmnoprint {
      left: -12px !important;
      top: 12px !important;
    }
  }
`

export const MapGradient = styled.div`
  position: absolute;
  top: 0;
  width: 7rem;
  height: 100%;
  pointer-events: none;
  z-index: 10;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.08), rgba(0, 0, 0, 0));
`
